export function defaultDataTransformer(response) {
  return response.json().then(result => result)
}

export function simpleTransformer(response) {
  return response
}

export function fetcher(resource, init = {}) {
  return fetch(resource, init)
}

export function transformDataFetcher(f, transformer) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    return f.apply(this, arguments).then(transformer)
  }
}

export function jsonTransformer(response) {
  return response.json()
}

export function raiseHttpErrorTransformer(response) {
  if (!response.ok) {
    // Only redirect on 403 if the server explicitly says to (blocked user).
    // Anonymous 403s (unauthenticated API calls on public pages) should not
    // redirect — just let the component handle the error silently.
    if (response.status === 403) {
      response.clone().json().then(data => {
        if (data && data.redirect) {
          window.location.href = data.redirect
        }
      }).catch(() => {})
    }
    throw response
  }
  return response
}

export function superagentJsonTransformer(response) {
  return response.body;
}
